import { useEffect } from 'react';

export default function useMachineGizmo(scene, selectedObjectIds) {
    useEffect(() => {
      if (!scene || !Array.isArray(selectedObjectIds)) return;

      

      // Scene içinden objeleri ID'ye göre bul
      const selectedObjects = scene.children.filter(obj =>
        selectedObjectIds.includes(obj.userData?.id)
      );

      

      // Önce tüm machine'lerin gizmo'larını görünmez yap
      scene.children.forEach(obj => {
        if (obj.userData?.type === 'machine') {
          // Sadece seçili OLMAYAN machine'lerin gizmo'larını gizle
          if (!selectedObjectIds.includes(obj.userData?.id)) {
            obj.traverse(child => {
              if (child.userData?.type === 'rotateGizmo') {
                child.visible = false;
              }
            });
          }
        }
      });

      // Seçili machine'lerin gizmo'larını görünür yap
      selectedObjects.forEach(obj => {
        if (obj.userData?.type === 'machine') {
          
          let gizmoFound = false;
          obj.traverse(child => {
            if (child.userData?.type === 'rotateGizmo') {
              
              child.visible = true;
              gizmoFound = true;
            }
          });
          if (!gizmoFound) {
            console.warn('⚠️ Machine içinde rotateGizmo bulunamadı!');
          }
        }
      });
    }, [scene, selectedObjectIds]);
  }
